import Question from '@evidentid/ido-lib/interfaces/Question';

import IncodeViewComponent from '@/components/fields/IncodeView.vue';
import { AttributesValues } from '@/store/interfaces/RawIdoActions';

import Field from './Field';

export default class IncodeField extends Field<any> {
    public override form = IncodeViewComponent;

    public isValid(_: Question, _value: any): boolean {
        return true;
    }

    public async encode(_question: Question, _value: any): Promise<AttributesValues> {
        // Incode submits data via webhook — nothing for the FE to encode.
        return {};
    }
}
